import app from '@core/configApp.ts'
import * as Sentry from '@sentry/vue'

import { setupLayouts } from 'virtual:generated-layouts'
import { createRouter, createWebHistory } from 'vue-router'
import { handleHotUpdate, routes } from 'vue-router/auto-routes'

const layoutRoutes = setupLayouts(routes)
for (const route of layoutRoutes) {
  if (route.name === 'login') {
    continue
  }
  route.meta ??= {}
  route.meta.requiresAuth = true
}
export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: layoutRoutes,
})

if (import.meta.hot) {
  handleHotUpdate(router)
}
if (import.meta.env.NODE_ENV !== 'development') {
  Sentry.init({
    app,
    dsn: 'https://ea57424807eb5bafd19e4af57babd344@sentry.vitrion.dev/65',
    integrations: [Sentry.browserTracingIntegration({ router })],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  })
}

router.beforeEach(async (to, _, next) => {
  const { isAuthenticated } = useAuthStore()
  if (to.meta.requiresAuth && !isAuthenticated.value && to.name !== '/auth') {
    next({ name: '/auth' })
  }
  else {
    next()
  }
})
